import React from 'react';
import { Loader } from 'semantic-ui-react';
import clsx from 'clsx';
import Error from '@/components/errors/Error';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import WorkspaceRequestConfirmationSuccess from './WorkspaceRequestConfirmationSuccess';
import Selectors from '../hooks/selectors';

const WorkspaceRequestConfirmation = ({ code, hideSteps }) => {
  const { saveStatus, saveErrors, markdown } = Selectors.useWorkspaceRequestConfirmation({ code });
  return (
    <div
      className={clsx(
        'aridhia-workspace-request-confirmation',
        'flex',
        'flex-column',
        'justify-between',
        hideSteps ? 'aridhia-wizard-content-no-steps' : 'aridhia-wizard-content',
      )}
    >
      <div>
        {saveStatus === states.PENDING && (<Loader active inline="centered" />)}
        {saveStatus === states.ERROR && (<Error error={firstErrorMessage(saveErrors)} />)}
        {saveStatus === states.SUCCESS && (<WorkspaceRequestConfirmationSuccess text={markdown} />)}
      </div>
    </div>
  );
};

export default WorkspaceRequestConfirmation;
